<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap dlg-hdr__icon-wrap--red"><mat-icon>delete</mat-icon></div>
    <div>
      <span>Eliminar tarjeta</span>
      <small class="dlg-hdr__sub" *ngIf="error == false">Esta acción no se puede deshacer</small>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">
  <div class="delete-info" *ngIf="error == false">
    <mat-icon>warning</mat-icon>
    <div class="delete-info__text">
      ¿Seguro que quieres eliminar esta tarjeta? Esta acción es permanente.
    </div>
  </div>
  <div class="delete-info delete-info--success" *ngIf="error">
    <mat-icon>check_circle</mat-icon>
    <div class="delete-info__text"><strong>Tarjeta eliminada</strong></div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-stroked-button (click)="closeDialog()">
    <mat-icon>close</mat-icon> Cerrar
  </button>
  <button mat-flat-button class="dlg-btn-delete" (click)="delete()" *ngIf="error == false">
    <mat-icon>delete</mat-icon> Eliminar
  </button>
</mat-dialog-actions>
